import styled from "styled-components";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import GA4Event from "@analytics/GoogleAnalytics/GA4Event";
import * as GA4Service from "@analytics/GoogleAnalytics/GA4Service";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { useUserContext } from "@contexts/UserContext";
import { CompletedOnboardingVideoEvent } from "@features/onboarding/AmplitudeOnboardingEvents";
import { updateRequiresOnboardingVideoValue } from "@features/user/service/UserSettingsService";
import Styles from "@themes/Styles";
import { redirectTo } from "@util/BrowserUtil";

const Root = styled.div`
    display: flex;
    flex-direction: column;
    width: 100dvw;
    height: 100dvh;
    align-items: center;
    justify-content: center;
    padding: 48px;
`;

const Backdrop = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 0 0;
    filter: blur(8px);
`;

const Modal = styled.div`
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    background: ${({ theme }) => theme.backgroundPrimary};
    border-radius: ${Styles.borderRadiusNormal};
    padding: 32px;
`;

const ModalTitle = styled.h1`
    font-size: 20px;
`;

const VideoContainer = styled.div`
    align-self: stretch;
    position: relative;
    padding-bottom: 62.445793581960096%;
    min-width: 50dvw;
    height: 0;
`;

const LoomEmbed = styled.iframe`
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export function OnboardingVideoPage() {
    const { user } = useUserContext();
    const amplitudeService = AmplitudeService.getInstance();

    return (
        <Root>
            <Backdrop src="https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fonboarding%2Fapp_screenshot.jpg?alt=media&token=b9f3218f-95da-4462-8b37-681b1fdff370" />
            <Modal>
                <ModalTitle>Tutorial</ModalTitle>
                <VideoContainer>
                    <LoomEmbed
                        src="https://www.loom.com/embed/ebca8c188624456b841bda024d03a7d5?sid=924edd2a-f90a-4e17-a197-e948e897a771?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true"
                        title="Demo video of LifeAt"
                        frameBorder="0"
                        allowFullScreen
                    />
                </VideoContainer>
                <LifeAtButtonV2
                    fullWidth
                    overrideTextColor={"#FFF"}
                    overrideBackgroundColor={Styles.buttonFillBlue}
                    disableHover={true}
                    isDisabled={user == null}
                    onClick={() => {
                        amplitudeService.logEvent(new CompletedOnboardingVideoEvent());
                        GA4Service.logEvent(GA4Event.COMPLETED_ONBOARDING_VIDEO);
                        updateRequiresOnboardingVideoValue(user.uid, false).then(() => {
                            redirectTo("/app");
                        });
                    }}
                >
                    Continue
                </LifeAtButtonV2>
            </Modal>
        </Root>
    );
}
